// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useRef} from 'react';
import {useHistory} from 'react-router-dom';
import cn from 'classnames';
import {t_order, t_zone_group} from '../../../../../hola/pub/ui/pro/cp/orders';
import {date_fmt, order_has_renew_error} from '../utils';
import Icon_warning from '../../../img/icons/16/warning.svg';
import Icon_renewal_off from '../../../img/icons/24/renewal_crossed.svg';
import Icon_calendar from '../../../img/icons/24/calendar_important.svg';
import Icon_card_failed from '../../../img/icons/24/bank_card_crossed.svg';
import {Settings_context} from '../../../../../hola/pub/settings_ctx';
import {LintHTMLDialogElement, Popup} from '../../../../pub/ui/popup/popup';
import date from '/util/date.js';
import {Plan_table_popup} from '../plan_table_popup/plan_table_popup';
import {Button} from '../../../../../hola/pub/lib/button';
import {api} from '../../../lib/api';
import etask from 'zetask';
import {use_screen} from '../../../../../hola/pub/lib/screen_util';
import {toolip_img_url} from '../../../../../hola/pub/ui/toolip_img_url';
import storage from '/util/storage.js';
import {Lottie} from '../../../../../shared/ui/lottie';

import styles from './subscr_expiration.module.less';
import popup_styles from '../plan_table_popup/plan_table_popup.module.less';

const Btn_loader = ()=>{
  return <Lottie autoplay loop width="96" height="96"
    src={toolip_img_url('animation/toolip_loader_72_grey.json')}/>;
};
interface t_icons {
    renewal_failed?: JSX.Element;
    renewal_off?: JSX.Element;
    calendar?: JSX.Element;
}
type t_reason = 'expire' | 'cancelled' | 'failed' | 'expired';
interface i_subscr_expiration_props {
    order: t_order;
    refresh_orders: ()=>void;
    renew_state: {loading: boolean};
    on_update_cc: (order: t_order)=>void;
    icons?: t_icons;
}
const Subscr_popup = (props: i_subscr_expiration_props)=>{
    const {order, renew_state, on_update_cc, refresh_orders} = props;
    const {theme} = useContext(Settings_context);
    const history = useHistory();
    const ref = useRef<LintHTMLDialogElement>(null);
    const {width} = use_screen();
    const is_mobile = width < 768;
    const on_manual_renew = (o: t_order)=>etask(function*(){
        const res = yield api.manual_oculus_renew(o._id);
        if (res.ok)
        {
            refresh_orders();
            history.push(`/dashboard/page/plans`
                +`?notification=auto_renew_success`);
        }
        else
            on_update_cc(o);
    });
    const enable_auto_renewal = ()=>on_manual_renew(order);
    const update_cc = ()=>on_update_cc(order);
    const renew_off = order.cancelled_manually;
    const time_diff = new Date(order.subscription_until).getTime()-Date.now();
    if (order_has_renew_error(order) || renew_off)
    {
        const reason: t_reason = order_has_renew_error(order) ?
            'failed' : time_diff <= 0 ? 'expired' : 'cancelled';
        let btn_text = reason == 'expired' ? 'Plan expired' :
            `Auto-renewal ${reason == 'cancelled' ? 'disabled' : 'failed'}`;
        let cancelled_renewal_cls = reason == 'expired' ?
            styles.expired_badge : null;
        let btn_text_cls = cn(theme.p10, theme.med,
            reason == 'failed' ||
            time_diff <= date.ms.DAY*1 && reason != 'expired' ?
              theme.color_err300 :
              theme[`color_n${reason == 'expired' ? 400 : 700}`]);
        let exp_soon_text: JSX.Element = null;
        if (reason == 'cancelled' && time_diff <= date.ms.DAY*1)
        {
            exp_soon_text = <>This is your last chance to keep your proxies
              active. Enable auto-renewal now to continue using them.</>;
            cancelled_renewal_cls = styles.exp_in_24h;
            if (reason == 'cancelled')
                btn_text = 'Last chance to renew';
        }
        else if (reason == 'cancelled' && time_diff <= date.ms.DAY*2)
        {
            exp_soon_text = <span className={cn(theme.P, theme.p14,
              theme.color_n600, styles.expire_soon_text)}>
              Your plan is ending soon.
              Enable auto-renewal to keep your IPs active.
            </span>;
            cancelled_renewal_cls = styles.exp_in_48h;
            if (reason == 'cancelled')
                btn_text = 'Ending soon';
        }
        const on_close = ()=>ref?.current.close();
        return <Popup {...(is_mobile ?
          {popup_cls: styles.renewal_disabled_popup_mobile, popup_ref: ref} :
          {show_on_hover: true, position: 'bottom'})}
          wrapper_cls={styles.subscr_popup_wrapper}
          button_cls={cn(cancelled_renewal_cls, styles.subscr_popup_btn,
            reason == 'failed' && styles.failed_renewal)}
          on_toggle={ev=>ev.stopPropagation()}
          button_text={<p className={btn_text_cls}>{btn_text}</p>}>
          <Renew_popup reason={reason} on_renew={enable_auto_renewal}
            icons={props.icons}
            loading={renew_state.loading} on_update_cc={update_cc}
            cancelled_renewal_cls={cancelled_renewal_cls}
            on_close={is_mobile ? on_close : null} data={{exp_soon_text}}
            btn_size='sm'/>
        </Popup>;
    }
    if (renew_off && time_diff < date.ms.DAY*5)
    {
        const rest = Math.ceil(time_diff / date.ms.DAY);
        return <Popup show_on_hover
          wrapper_cls={styles.subscr_popup_wrapper}
          button_cls={styles.subscr_popup_btn}
          on_toggle={ev=>ev.stopPropagation()}
          position="bottom"
          button_text={<span className={styles.color_warning}>
            <Icon_warning/>
          </span>}>
          <Renew_popup reason="expire" on_renew={enable_auto_renewal}
            icons={props.icons} btn_size='sm'
            loading={renew_state.loading} data={{rest}}
            on_update_cc={update_cc}
          />
        </Popup>;
    }
    return null;
};

export const Subscr_expiration_group = ({group}:{group: t_zone_group})=>{
    return <span className={styles.subscr_end}>
      {date_fmt(group.subscription_until)}
      {!group.free_group && group.subscription_cancelled &&
        <div
          className={styles.subscr_renewal_disabled}>
          Auto-renewal disabled
        </div>}
    </span>;
};

export const Subscr_expiration = (props: i_subscr_expiration_props)=>{
    const {order} = props;
    return <span className={styles.subscr_end}>
      {date_fmt(order.subscription_until)}
      {!order.free_zone && <Subscr_popup {...props}/>}
    </span>;
};
interface t_data {
    rest?: number;
    exp_soon_text?: JSX.Element;
}
interface i_renew_popup_props {
    reason: t_reason;
    loading: boolean;
    on_renew: ()=>void;
    on_update_cc: ()=>void;
    data?: t_data;
    cancelled_renewal_cls?: string;
    on_close?: ()=>void;
    cls?: string;
    btn_cl?: string;
    btn_size?: 's' | 'sm' | 'm';
    icons?: t_icons;
}
interface i_reason_params {
    icon: JSX.Element;
    title: JSX.Element;
    text: JSX.Element;
    hide_cc?: boolean;
    renew_caption?: string;
    renew_as_update_cc?: boolean;
}

const popups: Record<
    t_reason, (data?: t_data, icons?: t_icons)=>i_reason_params> = {
    expire: (data, icons)=>({
        icon: icons?.calendar ?? <Icon_calendar/>,
        title: <>Your plan will expire in {data?.rest} days</>,
        text: <>
          Please note that once your plan expires, all your current IPs
          will be removed. To keep your IPs active, please enable
          auto-renewal.
        </>,
    }),
    cancelled: (data, icons)=>({
        icon: icons?.renewal_off ?? <Icon_renewal_off/>,
        title: <>Auto-renewal is canceled</>,
        text: data?.exp_soon_text ??
        <>
          Please note that once your plan expires, all your current
          IPs will be removed. To keep your IPs active, please enable
          auto-renewal.
        </>,
    }),
    expired: (_, icons)=>({
        icon: icons?.renewal_off ?? <Icon_renewal_off/>,
        title: <>Your plan has expired</>,
        text: <>Since your plan was expired we removed all proxies related to
          this token.</>,
        hide_cc: true,
        renew_caption: 'Buy new plan',
        renew_as_update_cc: true,
    }),
    failed: (_, icons)=>({
        icon: icons?.renewal_failed ?? <Icon_card_failed/>,
        title: <>Plan auto-renewal failed</>,
        text: <>
          We couldn't process your payment.
          Update your details to keep your service active.
        </>,
        hide_cc: true,
        renew_caption: 'Update payment method',
        renew_as_update_cc: true,
    }),
};

const Renew_popup = (props: i_renew_popup_props)=>{
    const {reason, loading, on_renew, on_update_cc, data, cls, btn_cl,
      btn_size='sm', on_close=null} = props;
    const params = popups[reason](data, props.icons);
    const btn_disabled = loading;
    const btn_cls = cn(popup_styles.popup_btn, loading && popup_styles.loading,
        btn_cl);
    const btn_caption = <>
      <span className={popup_styles.btn_loader}><Btn_loader/></span>
      <span className={popup_styles.btn_text}>
        {params.renew_caption ?? 'Enable Auto-renewal'}
      </span>
    </>;
    return <Plan_table_popup
      cancelled_renewal_cls={props.cancelled_renewal_cls}
      cls={cls}
      reason={reason}
      icon={params.icon}
      title={params.title}
      text={params.text}
      on_close={on_close}
      cta={<div className={popup_styles.renew_popup_buttons}>
        <Button
          round={false}
          size={btn_size}
          disabled={btn_disabled}
          cls={btn_cls}
          caption={btn_caption}
          on_click={params.renew_as_update_cc ? reason != 'failed' ?
            ()=>{
              storage.clr('renew_update_cc_orig');
              on_update_cc();
            } : on_update_cc : on_renew}
        />
        {!params.hide_cc && <a onClick={on_update_cc}
          className={styles.update_cc_link}>
          Use different card</a>}
      </div>}
    />;
};
